<style scoped>
    .search-item {
        margin-top : 0px;
        margin-bottom : 0px;
    }
    .item-td {
        cursor:pointer;
    }
    .second-row {
        display: flex;
        font-size: 15px;
    }
    .sendTo {
        height: 20px;
        margin-right: 3%;
        text-align: center;
    }
    .from {
        width: 50px;
        background-color: lightgray;
    }
    .to {
        width: 30px;
        margin-left: 5%;
        color: white;
        background-color: gray;
    }
    .v-input--checkbox {
        margin-right: 30px;
    }
    .info-to{
        width: 50%;
        white-space: nowrap;
        text-overflow:ellipsis;
        overflow:hidden;
    }
    .text-align-right{
        text-align: right;
    }
    .white-space-nowrap{
        max-width: 0px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
</style>
<template>
    <v-container fluid>
        <v-container style="margin-top: 15px;">
            <v-row>
                <v-col cols="12" xl="6" class="text-h4">却下一覧</v-col>
            </v-row>
        </v-container>
        <v-row justify="center">
            <v-col cols="12">
                <div class="text-align-right">
                    <page_offset_limit_component :total="total" :items_per_page="itemsPerPage" :page="page"></page_offset_limit_component>    
                </div>
                <v-data-table
                    :headers="headers"
                    :items="items"
                    :page.sync="page"
                    :items-per-page="itemsPerPage"
                    @page-count="pageCount = $event"
                    disable-sort
                    hide-default-footer
                >
                    <template v-slot:body="props">
                            <tbody>
                                <tr v-for="(item, index) in props.items" :key="index" @click="itemAction(item.object_id)">
                                    <td class="item-td white-space-nowrap" align="left">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span
                                                class="info-to"
                                                v-bind="attrs"
                                                v-on="on"
                                                >
                                                    {{ item.contract_name }}
                                                </span>
                                            </template>
                                            <span>{{ item.contract_name }}</span>
                                        </v-tooltip>
                                        <div class="second-row">
                                            <div class="sendTo to">To</div>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <span
                                                    class="info-to"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    >
                                                        {{ item.to_destination_user_names }}
                                                    </span>
                                                </template>
                                                <span>{{ item.to_destination_user_names }}</span>
                                            </v-tooltip>
                                        </div>
                                    </td>
                                    <td class="item-td white-space-nowrap" align="center">
                                        <div>
                                            <div style="text-align: left;">{{ item.last_update_name }} {{ item.last_update_email_address }}</div>
                                            <div style="text-align: left;">{{ getDateWithWeekTimeText(item.rejection_date) }}</div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                    </template>
                </v-data-table>
                <v-pagination
                    v-model="page"
                    :length="pageCount"
                ></v-pagination>
            </v-col>
        </v-row>

    </v-container>
</template>
<script>
    import page_offset_limit_component from '../../components/common/PageOffsetLimitComponent.vue';
    import { dateformatMixin } from '../../mixins/dateformatMixin.js';
    export default {
        data() {
            return {
                //総件数
                total:0,
                // ページ数
                page: 1,
                // 最大ページ数
                pageCount: 0,
                // 1ページあたりの項目数
                itemsPerPage: 10,
                // テーブルヘッダー
                headers: [
                    { text: "件名", value: "contract_name", align: "left", width: "50%",},
                    { text: "却下日", value: "rejection_date", align: "left", width: "50%",},
                ],
            };
        },
        mixins: [dateformatMixin],
        components: {
	 　　　page_offset_limit_component,
	 　 },
        props: {
            navi: [],
            items : Array
        },
        // 初期表示のデータ
        mounted() {
            this.setTotal();
        },
        methods: {
            setTotal() {
                this.total = this.items.length;
            },
            // 契約書概要へのリンク
            itemAction(object_id) {
                window.location.href = "/documents/document-management/summary/" + object_id;
            },
        },
    };
</script>